import _axiosModule from 'axios';
import AppUtils from './app-utils';
import { handleOmniture } from './omniture';
import Cookies from 'universal-cookie';
import GscopeMfeTools from './tools';
import _ from 'lodash';

const cookies = new Cookies();

export const getUserMetaData = () =>
    localStorage.getItem('ngStorage-userMetaData') ? JSON.parse(localStorage.getItem('ngStorage-userMetaData')) : {};
export function createAxiosInstance() {
    const _axios = _axiosModule.create();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    _axios.all = function all(promises) {
        return Promise.all(promises);
    };
    _axios.interceptors.request.use(
        (request) => {
            const authToken = cookies.get('authToken');
            const authHeader = cookies.get('authHeader');
            const currentMarket = cookies.get('currentMarket') || 'us';
            const loggedInUserName = cookies.get('loggedInUserName') || 'app';
            const tokenUserId = cookies.get('tokenUserId');
            const _userMetaData = getUserMetaData();
            const userMetaData = _.isEmpty(_userMetaData)
                ? { authToken, authHeader, loggedInUserName, currentMarket }
                : _userMetaData;
            const appUtils = AppUtils.get();

            if (userMetaData && userMetaData.authToken) {
                Object.assign(
                    request.headers,
                    userMetaData && userMetaData.authToken
                        ? {
                              'x-auth-token': userMetaData.authToken,
                              loggedInUserId: userMetaData.loggedInUserName || loggedInUserName,
                              tokenUserId: userMetaData.tokenUserId || tokenUserId,
                              Authorization: userMetaData.authHeader,
                              currentMarket: (appUtils && appUtils.currentMarket) || currentMarket,
                          }
                        : {},
                );
                if (appUtils && appUtils.omnitureParam) {
                    return handleOmniture(userMetaData, appUtils.omnitureParam, request);
                }
                return request;
            } else {
                Object.assign(request.headers, {
                    loggedInUserId: loggedInUserName,
                    currentMarket,
                });
            }
            return request;
        },
        (error) => error,
    );
    let flagOfClockout = 0;
    _axios.interceptors.response.use(
        (response) => {
            const pathName = window.location.pathname;
            if (
                (response.data === 'Not a valid user' ||
                    response.data === 'expired token' ||
                    response.data === 'clocked status check failed - clocked out' ||
                    response.data === 'clocked status check failed - not found' ||
                    response.data === 'clocked status check failed - unknown') &&
                pathName != '/' &&
                pathName.indexOf('/login') == -1
            ) {
                if (response.data == 'clocked status check failed - clocked out') {
                    flagOfClockout++;
                    if (flagOfClockout == 1) {
                        clearStorage();
                        alert('You are currently clocked out. This feature is only available when you are clocked In');
                        window.location.href = '/';
                    }
                } else {
                    clearStorage();
                    window.location.href = '/';
                }
            }
            return response;
        },
        (error) => {
            if (error.response && error.response.status >= 400) {
                const userMetaData = getUserMetaData();
                const appUtils = AppUtils.get();
                if (userMetaData && userMetaData.authToken && appUtils && appUtils.omnitureParam) {
                    handleOmniture(userMetaData, appUtils.omnitureParam, error.response.config, error.response);
                }
            }
            throw error;
        },
    );
    Object.assign(_axios, _.pick(_axiosModule, ['Cancel', 'CancelToken', 'isCancel']));
    return _axios;
}
export const clearStorage = () => {
    document.cookie.split(';').forEach((c) => {
        if (c.indexOf('redirectUrl') == -1) {
            document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
        }
    });

    localStorage.clear();
};
const axios = createAxiosInstance();

export const getUserPrefs = ({ userId }) => {
    if (GscopeMfeTools.isStrideInfra()) {
        if (Boolean(cookies.get('loggedIn')) === true && userId) {
            return axios.get(`/api/gateway/provider-userpref/pref?userId=${userId}`, {
                headers: { loggedInUserId: userId },
            });
        } else {
            return { data: {} };
        }
    }
    if (window.location.pathname.indexOf('wfsLite') !== -1) {
        return axios.get(`/api/gateway/provider-common/pref?userId=${userId}`, { headers: { loggedInUserId: userId } });
    }
    return axios.get(`/api/gateway/provider-userpref/pref?userId=${userId}`, { headers: { loggedInUserId: userId } });
};

export const manageUserPref = (payload) => {
    if (GscopeMfeTools.isStrideInfra()) {
        if (Boolean(cookies.get('loggedIn')) === true) {
            return axios.post('/api/gateway/provider-userpref/pref', { payload });
        } else {
            return { data: {} };
        }
    }
    if (window.location.pathname.indexOf('wfsLite') !== -1) {
        return axios.post('/api/gateway/provider-common/pref', { payload });
    }
    return axios.post('/api/gateway/provider-userpref/pref', { payload });
};

export const getFAQList = () => axios.get('/api/gateway/provider-common/page?pageName=faq');

export const getRouteConfigs = () => axios.get('/api/gateway/ccm/app/routeConfigs');

export const bulkUpload = (formData, useWasm) => {
    const url = useWasm ? '/api/gateway/v2/file/bulk/uploadv2' : '/api/gateway/file/bulk/upload';
    return axios.post(url, formData, {
        headers: {
            'content-type': 'multipart/form-data',
        },
    });
};

export const bulkUploadHistory = (userId, bulkUpdateHistory) => {
    let path = `/api/gateway/bulk/history?userId=${userId}`;

    if (bulkUpdateHistory) path += '?uploadType=bulkUpdate';

    return axios.get(path);
};
export const getOmnitureDataObj = () => axios.get('/omniturePageData.json');

export const uploadErrorList = (transactionId) => axios.get(`/api/gateway/bulk/status?transactionId=${transactionId}`);

export const getBUMartID = (currentMarket, loggedInUserId) =>
    axios.get(`/api/gateway/getCCMConfig/${currentMarket}`, { headers: { loggedInUserId } });
export const getDownStreamMapping = () => axios.get('/api/gateway/ccm/app/processMap');
export const getSupportedLngs = () => axios.get('/api/gateway/ccm/app/supportedLngs');
export const getMfeReroutingMapping = _.memoize(() => axios.get('/api/gateway/ccm/app/mfeRerouting'));
export const getAlertConfig = () =>
    axios.get('/api/gateway/ccm/app/alertConfig', { headers: { loggedInUserId: 'system' } });
export const getNotificationConfig = () => axios.get('/api/gateway/ccm/app/notificationConfig');

export const getQuickTourInfo = (path, market, username, configKey) =>
    axios.get(`/api/gateway/cms/getCustomConfig?configKey=${configKey}&path=${path}&market=${market}`, {
        headers: { loggedInUserId: username },
    });
export const getWfsSellerInfo = () => axios.get('/resource/user/profile/info');
export const logoutWfsSeller = () => axios.get('/resource/logout');

export const getExternalConfig = () =>
    axios.get('/api/gateway/ccm/app/externalModuleConfig', { headers: { loggedInUserId: 'user' } });

export const getTypeAheadConfig = () =>
    axios.get('/api/gateway/ccm/app/typeAheadConfig', { headers: { loggedInUserId: 'user' } });

export const getMfeConfig = () => axios.get('/api/gateway/ccm/app/mfeConfig');
export const getIssueCollectorEnvSupport = () =>
    axios.get('/api/gateway/ccm/app/issueCollectorEnvSupport', { headers: { loggedInUserId: 'user' } });

export const downloadOriginalFile = (transactionID) =>
    axios.post(
        `/api/gateway/download/bulk/originalFileDownloadV2?tid=${transactionID}`,
        {},
        { responseType: 'arraybuffer' },
    );

export const downloadErrorReport = (transactionID) =>
    axios.post(
        `/api/gateway/download/bulk/errorFileDownloadV2?tid=${transactionID}`,
        {},
        { responseType: 'arraybuffer' },
    );

export const downloadSuccessReport = (transactionID) =>
    axios.get(`/api/gateway/bulk/successFileDownload?tid=${transactionID}`);

export const getAsdel = () => axios.get(`api/gateway/ccm/app/asdel`);

export const getLmsPromise = (storeNo) => axios.get(`/api/gateway/lms/promise?id=${storeNo}`);

export const getRetailLinkLogoutUrl = (baseUrl, logoutType, path, userId, clientId) => {
    if (GscopeMfeTools.isStrideInfra() || clientId) {
        return axios.get(
            `/api/gateway/retailLink/retailLinkLogoutUrl?url=${baseUrl}${
                path ? path : ''
            }&logoutType=${logoutType}&clientId=${clientId}`,
            { headers: { loggedInUserId: userId } },
        );
    }
    return axios.get(
        `/api/gateway/retailLink/retailLinkLogoutUrl?url=${baseUrl}${path ? path : ''}&logoutType=${logoutType}`,
        { headers: { loggedInUserId: userId } },
    );
};

export const getWhitelistRoutes = (path, market, userId, auth, token) =>
    axios.get(`/api/gateway/cms/fetchConfigurations?path=${path}&market=${market}`, {
        headers: { loggedInUserId: userId, Authorization: auth, 'x-auth-token': token },
    });

export const getCmsConfig = (path, market, config) =>
    axios.get(`/api/gateway/cms/getConfig?path=${path}&market=${market}`, config);

export const getTranslationCCM = () =>
    axios.get('/api/gateway/ccm/app/gscopeCommonLang', { headers: { loggedInUserId: 'user' } });
